<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @click:outside="dialog = false"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="green"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        Excelexport
      </v-btn>
    </template><v-card>
      <v-card-title>
        <span class="headline">Export Excel</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-date-picker
                v-model="dates"
                range
                :min="minStart"
                no-title
                :first-day-of-week="1"
                locale="de-de"
                full-width
                flat
                class="elevation-0"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-col class="d-flex justify-end">
          <v-btn
            color="green"
            outlined
            class="my-2"
            @click="selectAllDate"
          >
            Select All
          </v-btn>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn
            color="green"
            outlined
            class="my-2"
            @click="selectThisMonth"
          >
            This Month
          </v-btn>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn
            color="green"
            outlined
            class="my-2"
          >
            <download-excel
              :fetch="loadCustomers"
              :export-fields="fields"
              worksheet="Dashboardexport"
              stringify-long-num
              name="vOffice-Dashboardexport"
            >
              <div class="d-flex align-center">
                <span
                  class="mr-1 font-weight-medium"
                  style="font-size:1.2rem"
                >Export</span>
                <svg
                  style="width:24px;height:24px"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </div>
            </download-excel>
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getFirebaseToken } from '@/firebase'
  export default {
    name: 'DownloadExcelComponent',
    // eslint-disable-next-line
    props: ['ram', 'law', 'german', 'foreign'],
    data: () => (
      {
        dates: [],
        dialog: false,
        fields: {
          'abboniert am': 'date_formated',
          'RMO Kd.-Nr.': 'rmo_customer_nr',
          Status: {
            field: 'Status',
            callback: (value) => {
              return ''
            },
          },
          WV: {
            field: 'WV',
            callback: (value) => {
              return ''
            },
          },
          Bearbeiter: {
            field: 'Bearbeiter',
            callback: (value) => {
              return ''
            },
          },
          Telefonvermerk: 'telefonvermerk',
          'Lead/Nachricht': {
            field: 'Lead/Nachricht',
            callback: (value) => {
              return ''
            },
          },
          Lizenznehmer: 'lastName',
          'E-Mail-Adresse bei Registrierung': 'email',
          Postleitzahl: 'zipCode',
          Ort: 'city',
        },
        json_meta: [
          [{
            key: 'charset',
            value: 'utf-8',
          }],
        ],
      }
    ),

    computed: {
      minStart () {
        return new Date('2020-01-01').toISOString().slice(0, 10)
      },
    },
    mounted () {
      this.selectThisMonth()
    },
    methods: {
      async loadCustomers () {
        const response = await fetch(`${process.env.VUE_APP_FUNCTIONS}/allCustomers/${this.dates[0]}:${this.dates[1]}`, {
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + (await getFirebaseToken()),
            'Content-Type': 'application/json;charset=UTF-8',
          },
        })
        const responseJson = await response.json()

        if (responseJson.success) {
          const customers = []
          Object.entries(responseJson.results).forEach(entry => {
            const key = entry[0]
            const customer = entry[1]

            if (!customer.rmo_customer_nr && key.split('.')[1] === 'voffice') {
              customer.rmo_customer_nr = 'N/A'
            }
            const tempObject = {
              domainLink: key,
              date_formated: this.moment(customer.createdAt).locale('de').format('DD.MM.YYYY'),
              telefonvermerk: `${customer.company_name}

              ${customer.phone}`,
              ...customer,
            }
            customers.push(tempObject)
          })

          const exportedCustomer = []

          if (this.ram) {
            const ramCustomer = customers.filter(item => item.domainLink.split('.')[1] === 'ra-micro' && (/^\+?\d+$/.test(item.domainLink.split('.')[0].split('_')[1]) || /^\+?\d+$/.test(item.domainLink.split('.')[0].split('-')[1])))
            exportedCustomer.push.apply(exportedCustomer, ramCustomer)
          }
          if (this.law) {
            const lawCustomer = customers.filter(item => item.domainLink.split('.')[1] === 'ra-micro' && !(/^\+?\d+$/.test(item.domainLink.split('.')[0].split('_')[1]) || /^\+?\d+$/.test(item.domainLink.split('.')[0].split('-')[1])))
            exportedCustomer.push.apply(exportedCustomer, lawCustomer)
          }
          if (this.german) {
            const germanCustomer = customers.filter(item => item.domainLink.split('.')[1] === 'voffice' && (item.state === 'DE' || item.state?.value === 'DE' || item.state === 'Deutschland'))
            exportedCustomer.push.apply(exportedCustomer, germanCustomer)
          }
          if (this.foreign) {
            const foreignCustomer = customers.filter(item => item.domainLink.split('.')[1] === 'voffice' && !(item.state === 'DE' || item.state?.value === 'DE' || item.state === 'Deutschland'))
            exportedCustomer.push.apply(exportedCustomer, foreignCustomer)
          }

          return exportedCustomer
        } else {
          console.log(response.message)
        }
      },
      selectThisMonth () {
        let startDate = new Date()
        let endDate = new Date()
        startDate.setDate(1)
        startDate = startDate.toISOString().slice(0, 10)
        endDate = endDate.toISOString().slice(0, 10)
        this.dates = [startDate, endDate]
      },
      selectAllDate () {
        this.dates = [process.env.VUE_APP_VOFFICEINITDATE, new Date().toISOString().slice(0, 10)]
      },

    },
  }
</script>
<style>
  .v-date-picker-table {
    height: 100% !important;
  }
</style>
